module.exports = {"540421100":"工布江达镇","540421101":"金达镇","540421102":"巴河镇","540421200":"错高乡","540421201":"朱拉乡","540421202":"仲莎乡","540421203":"江达乡","540421204":"娘蒲乡","540421205":"加兴乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540421.json
// module id = 2521
// module chunks = 0